/**
 * Auth API Hooks
 * TanStack Query hooks for authentication
 */

import { useMutation } from "@tanstack/react-query";

import { useAuthStore } from "../store/authStore";

import type { LoginCredentials, AuthResponse } from "../types/auth.types";

// TODO: Replace with actual API client
const loginRequest = async (
  credentials: LoginCredentials,
): Promise<AuthResponse> => {
  // Placeholder for actual API integration
  return {
    user: {
      id: "user-1",
      email: credentials.email,
      firstName: "User",
      lastName: "Account",
      role: "user",
      isVerified: true,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    },
    token: "mock-jwt-token",
  };
};

export const useLogin = () => {
  const setAuth = useAuthStore((state) => state.setAuth);

  return useMutation({
    mutationFn: loginRequest,
    onSuccess: (data) => {
      setAuth(data.user, data.token);
    },
  });
};
